import React from "react";

import { classNames } from "../../../../utils/utils";
import styles from "./LoadingScreen.module.css";

type Props = {
  title?: string;
  subtitle?: string;
  className?: string;
  children?: React.ReactNode;
};

export const LoadingScreen: React.FC<Props> = ({
  children,
  title,
  subtitle,
  className = "",
}) => {
  return (
    <div className={classNames(styles.loaderContainer, className)}>
      <svg
        width="50"
        height="50"
        viewBox="0 0 50 50"
        className={styles.svgLoader}
      >
        <circle
          className={styles.loaderCircle}
          cx="25"
          cy="25"
          r="20"
          fill="none"
          strokeWidth="5"
        />
      </svg>
      {title && <h1 className={styles.title}>{title}</h1>}
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      {children && <div>{children}</div>}
    </div>
  );
};
